<script context="module">
  /**
   * @typedef {Object} FilterItem
   * @property {string} id
   * @property {string} label
   * @property {boolean} [isChecked]
   */
</script>

<script>
  import Button from "../atoms/Button.svelte";
  import Icon from "../atoms/Icon.svelte";
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  /**
   * The filter items in the hero section
   * @type {FilterItem[]}
   */
  export let filterItems = [];

  function handleFilterButtonClick() {
    dispatch("toggleFilterList");
  }

  function handleOptionButtonClick(filterItemId) {
    dispatch("deselectFilterItem", {
      filterItemId
    });
  }
</script>

<div class="flex flex-wrap gap-x-2 gap-y-2 pt-7.5 lg:pt-12.5">
  <Button
    id="show-filters"
    on:click={handleFilterButtonClick}
    variant="filled"
    label="Filter"
    theme="white"
    iconAlignment="trailing"
    iconName="filter"
  >
    <Icon slot="icon" name="filter" />
  </Button>
  {#each filterItems as filterItem}
    <Button
      id={`remove-${filterItem.id}`}
      on:click={handleOptionButtonClick(filterItem.id)}
      variant="outline"
      label={filterItem.label}
      theme="white"
      iconAlignment="trailing"
      iconName="close"
    >
      <Icon slot="icon" name="close" />
    </Button>
  {/each}
</div>
